var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialchannelTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.579 5.333c-2.713 0-4.913 2.242-4.913 5.008 0 0.393 0.043 0.775 0.127 1.141-4.083-0.209-7.703-2.203-10.126-5.232-0.423 0.74-0.665 1.6-0.665 2.518 0 1.737 0.867 3.27 2.186 4.168-0.805-0.026-1.563-0.251-2.225-0.626-0 0.021-0 0.042-0 0.063 0 2.426 1.694 4.451 3.941 4.911-0.412 0.114-0.846 0.176-1.294 0.176-0.317 0-0.624-0.031-0.924-0.090 0.625 1.99 2.439 3.438 4.589 3.478-1.681 1.343-3.8 2.144-6.102 2.144-0.397 0-0.788-0.024-1.172-0.070 2.174 1.421 4.757 2.25 7.531 2.25 9.037 0 13.978-7.631 13.978-14.249 0-0.217-0.005-0.433-0.014-0.648 0.96-0.706 1.793-1.588 2.451-2.592-0.881 0.398-1.828 0.668-2.822 0.789 1.014-0.62 1.793-1.601 2.16-2.771-0.949 0.574-2.001 0.991-3.12 1.215-0.896-0.973-2.173-1.582-3.586-1.582z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialchannelTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/socialchannel-twitter.e859e13c5caba41c71c58ec7674eea29.svg";